import { DEFAULT_LOADABLE_STATE, Loadable, LoadableMock, RecursivePartial } from '@aiwyn/shared';
import { AiwynPaymentMethod, AiwynPaymentMethodMock, BillingDetails, PaymentMethodType } from '@aiwyn/api';
import { merge } from 'ts-deepmerge';
import { PaymentMethodMode } from './payment-method-metadata.models';

export interface BasePaymentPlatformStateModel {
  defaultPaymentMethodId: Loadable<string>;

  savedPaymentMethods: Loadable<AiwynPaymentMethod[]>;
  selectedSavedPaymentMethodId?: string;

  temporaryPaymentMethod?: AiwynPaymentMethod;

  newPaymentMethodType?: PaymentMethodType;
  paymentMethodMode?: PaymentMethodMode;

  newBillingDetails?: BillingDetails;
}

export const DEFAULT_BASE_PAYMENT_PLATFORM_STATE_MODEL: BasePaymentPlatformStateModel = {
  savedPaymentMethods: DEFAULT_LOADABLE_STATE,
  defaultPaymentMethodId: DEFAULT_LOADABLE_STATE,
};

export class BasePaymentPlatformStateModelMock {
  protected _model: BasePaymentPlatformStateModel = {
    defaultPaymentMethodId: new LoadableMock('pm_1').model(),
    savedPaymentMethods: new LoadableMock([new AiwynPaymentMethodMock({ id: 'pm_1' }).model()]).model(),
    selectedSavedPaymentMethodId: 'pm_1',
    temporaryPaymentMethod: undefined,
    newPaymentMethodType: undefined,
    paymentMethodMode: PaymentMethodMode.SAVED,
    newBillingDetails: undefined,
  };

  constructor(overrides: RecursivePartial<BasePaymentPlatformStateModel> = {}) {
    this._model = merge.withOptions(
      { mergeArrays: false },
      this._model,
      overrides,
    ) as unknown as BasePaymentPlatformStateModel;
  }

  public model(): BasePaymentPlatformStateModel {
    return this._model;
  }
}
